import { alpha, InputBase, styled } from "@mui/material";
import { blob } from "stream/consumers";
import { StyleguideSavioColors } from "../../../../configuration/themeSettings";

export const SearchContainer = styled("div", {
  label: "AppSearch-search-container",
})(({ theme }) => ({

  flexGrow: 1,
}));

export const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.9),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 1),
  },
  marginRight: "auto",
  marginLeft: "auto",
  width: 380,

  [theme.breakpoints.down(1200)]: {
    width: 'auto',
    marginLeft: 10,
    marginRight: 10,
  },

}));

export const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 1),
  height: "100%",
  position: "absolute",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  right: 0,
  top: 0,
  color: theme.palette.primary.main,
  cursor: "pointer",

  ".MuiSvgIcon-root":{
    fontSize: 17,
  }
}));

export const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: StyleguideSavioColors.text.black,
  marginRight: 56,
  display: "block",
  "& .MuiInputBase-input": {
    padding: theme.spacing("9px", 1, "7px", 0),
    // vertical padding + font size from searchIcon
    //paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    paddingLeft: theme.spacing(2),
    transition: theme.transitions.create("width"),
    width: "100%",
    fontSize: 14,
    height: '1em',
    [theme.breakpoints.up("md")]: {
      //   width: "20ch",
    },
  },
}));
